// full library entry point.

'use strict';
module.exports = require('./dist/bsocket');
